import { ConsultationTypeEnum } from '@/shared/enums';
import { fetch } from '@/shared/fetch';

export const fetchVideoConsultationTypes = () => {
    return fetch<ConsultationTypeEnum[]>(
        '/api/caregiverspace/consultations/types/video',
    );
};
